"use client"

import { Component } from "react"
import redux from "../../common/Redux"
import Colors from "../../common/Colors"
import API, { URL_PATH } from "../../services/API"
import { DatePicker } from "../../components/DatePicker"

class MainScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reviews: [],
      fromDate: "",
      toDate: "",
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 0,
      loading: false,
    }
  }

  componentDidMount() {
    this.fetchReviews(1)
    // Apply fixed grid layout
    this.applyGridLayout()
    // Add resize listener
    window.addEventListener("resize", this.applyGridLayout)
  }

  componentWillUnmount() {
    // Clean up resize listener
    window.removeEventListener("resize", this.applyGridLayout)
  }

  applyGridLayout = () => {
    const reviewGrid = document.getElementById("reviewGrid")
    if (!reviewGrid) return

    const width = window.innerWidth

    // Always show 4 columns regardless of screen size
    reviewGrid.style.gridTemplateColumns = "repeat(4, 1fr)"
  }

  handleDateChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleFilterSubmit = (e) => {
    e.preventDefault()
    this.fetchReviews(1)
  }

  fetchReviews = async (page = 1) => {
    const { fromDate, toDate } = this.state
    this.setState({ loading: true })

    try {
      const { status, message, data } = await API(
        this,
        "get",
        URL_PATH.reviews(page, fromDate, toDate),
        {},
        {},
        page === 1,
      )

      if (status === "success") {
        const { current_page, data: reviews, last_page, per_page, total } = data

        this.setState({
          reviews: current_page === 1 ? reviews : [...this.state.reviews, ...reviews],
          current_page,
          last_page,
          per_page,
          total,
          loading: false,
        })

        // Apply grid layout after data is loaded
        setTimeout(this.applyGridLayout, 0)
        return
      }

      if (status === "error") {
        this.props.okDialog(message)
      } else {
        this.props.okDialog("Something went wrong")
      }
    } catch (error) {
      console.error("Error fetching reviews:", error)
      this.props.okDialog("An error occurred while fetching reviews")
    } finally {
      this.setState({ loading: false })
    }
  }

  loadMoreReviews = () => {
    const { current_page, last_page } = this.state
    if (current_page < last_page) {
      this.fetchReviews(current_page + 1)
    }
  }

  renderStars = (count) => {
    return "⭐".repeat(count)
  }

  renderEmptyState = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "250px",
          border: "2px dashed #FCD34D",
          borderRadius: "8px",
          backgroundColor: "#FFFBEB",
          padding: "32px",
        }}
      >
        <div
          style={{
            width: "64px",
            height: "64px",
            marginBottom: "16px",
            color: "#FBBF24",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ width: "100%", height: "100%" }}
          >
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
          </svg>
        </div>
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#1F2937",
          }}
        >
          No Reviews Yet
        </h3>
        <p
          style={{
            fontSize: "14px",
            color: "#6B7280",
            textAlign: "center",
            marginTop: "8px",
          }}
        >
          Reviews from your customers will show up here once they're submitted.
        </p>
      </div>
    )
  }

  render() {
    const { reviews, fromDate, toDate, current_page, last_page, loading } = this.state

    const containerStyle = {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "16px",
    }

    const headerStyle = {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "24px",
    }

    const formContainerStyle = {
      marginBottom: "32px",
      padding: "10px",
      // backgroundColor: "#041A29",
      boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
      borderLeft: "4px solid #FFC857",
    }

    const formTitleStyle = {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "16px",
      color: "white",
    }

    const formRowStyle = {
      display: "flex",
      flexDirection: "column",
    }

    const formGroupStyle = {
      flex: "1",
    }

    const labelStyle = {
      display: "block",
      fontSize: "14px",
      fontWeight: "500",
      marginBottom: "4px",
      color: "white",
    }

    const inputStyle = {
      width: "50%",
      padding: "8px 12px",
      border: "1px solid #D1D5DB",
      borderRadius: "6px",
      outline: "none",
    }

    const buttonStyle = {
      padding: "8px 16px",
      backgroundColor: "#FFC857",
      color: "#78350F",
      borderRadius: "6px",
      border: "none",
      fontWeight: "500",
      cursor: "pointer",
      marginTop: "16px",
    }

    // Fixed grid container with 4 columns
    const gridContainerStyle = {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "16px",
    }

    // Updated card style with black background and yellow border
    const cardStyle = {
        borderLeft: "4px solid #FFC857",
      padding: "16px",
      backgroundColor: "#041A29",
      boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
    }

    const cardHeaderStyle = {
      display: "flex",
      alignItems: "center",
      marginBottom: "12px",
    }

    const avatarStyle = {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "12px",
      color: "white",
      fontWeight: "bold",
      backgroundColor: Colors.primary,
    }

    const userInfoStyle = {
      display: "flex",
      flexDirection: "column",
    }

    // Updated text styles to white
    const userNameStyle = {
      fontWeight: "600",
      color: "white",
    }

    const dateStyle = {
      fontSize: "12px",
      color: "#CCCCCC",
    }

    const starsStyle = {
      marginBottom: "12px",
      fontSize: "18px",
      color: "#FBBF24",
    }

    // Updated text color to white
    const reviewContentStyle = {
      borderTop: "1px solid #333333",
      paddingTop: "12px",
      marginTop: "8px",
      fontSize: "14px",
      color: "white",
    }

    const loadMoreContainerStyle = {
      marginTop: "24px",
      textAlign: "center",
    }

    const loadMoreButtonStyle = {
      padding: "8px 16px",
      backgroundColor: "#FFC857",
      color: "#78350F",
      fontWeight: "500",
      borderRadius: "6px",
      border: "none",
      cursor: "pointer",
    }

    const noMoreStyle = {
      marginTop: "24px",
      textAlign: "center",
      color: "#6B7280",
    }

    return (
      <div style={containerStyle}>
        <h2 style={headerStyle}>Customer Feedback</h2>
</div>

    )
  }
}

export default redux(MainScreen)

